import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { SUB_CATEGORIES_FETCH } from "../actions/types";
import { subCategoriesFetchSuccess } from "../actions/SubCategoryActions";
import { showErrorMessage, showSuccessMessage } from "../actions/NotifyActions";
import { authorizationHeader, getErrorMessage } from "../util/apiUtil";
import { intl } from "../lngProvider/IntlGlobalProvider";
import { reset } from "redux-form";
import axios from "axios";
import _ from "lodash";

// API
const subCategoriesFetchRequest = async payload => {
    let url = `${process.env.REACT_APP_API_URL}/api/subcategories`;
    let params = { ...payload };
    params = _.omitBy(params, _.isEmpty);

    return await axios
        .get(url, {
            headers: authorizationHeader("bearer"),
            params: params
        })
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
};

// WORKER
function* subCategoriesFetch({ payload }) {
	try {
		const data = yield call(subCategoriesFetchRequest, payload);
		yield put(subCategoriesFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

// WATCHER
function* subCategoriesFetchWatcher() {
    yield takeEvery(SUB_CATEGORIES_FETCH, subCategoriesFetch);
}

export default function* rootSaga() {
    yield all([
        fork(subCategoriesFetchWatcher),
    ]);
}